import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: "root" })
export class LoginService {
  constructor(private http: HttpClient) {}

  public getToken(noEmployeeOrEmail: string, password: string) {

    const options = { headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded') };

    const body = new URLSearchParams();

    body.set('username', window.btoa(noEmployeeOrEmail));
    body.set('password', window.btoa(password));
    body.set('grant_type', 'password');

    return this.http.post(`${environment.serverUrl}token`, body.toString(), options);
  }
}
